/*
*
* File JS per la Single Team
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroPage from 'components/hero-page/hero-page';
import bannerSwiper from 'components/banner-swiper/banner-swiper';
import bannerContact from 'components/banner-contact/banner-contact';

// //--------------------------------------------------------------------//

// // IMPORT STILE SPECIFICO PAGINA
// //--------------------------------------------------------------------//

import './single-team.scss';

// //--------------------------------------------------------------------//


// // INIT COMPONENTI
// //--------------------------------------------------------------------//

bannerSwiper();

// //--------------------------------------------------------------------//